import script from "./number-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./number-input.vue?vue&type=script&lang=ts&setup=true"

import "./number-input.vue?vue&type=style&index=0&id=115fdb28&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115fdb28"]])

export default __exports__